//
// AbstractEntry.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/RendererModel";
import "./EntryTextItem";
import "../core/styles/FillAttributes";
import "../core/styles/LineAttributes";
import "../core/Pad";
import "./EntryOuterPadType";
import "../core/styles/TextAttributes";
import "../core/TextFitPolicy";
import "../core/HorizontalAlignment";
import "../core/VerticalAlignment";
import "../layoutOverlay/AutoAlignPositions";

var AbstractEntry = createModule("gtl::AbstractEntry", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::RendererModel"], EventDispatcher, [
    ,
    {
        border: 2,
        rotate: 4,
        textItems: [1],
        opaque: 2,
        hAlign: 4,
        outerPadType: 4,
        outerPad: 1,
        backgroundAttributes: 1,
        autoAlign: 1,
        vAlign: 4,
        textFitPolicy: 4,
        pad: 1,
        textAttributes: 1,
        shortText: 7,
        borderAttributes: 1,
    },
    ,
    ,
    ,
    ,
    ,
]);
export default AbstractEntry;
